
angular.module('mtic.components.navbar')
.directive('navBarTeacherTest', function (EventManager, $timeout, $log, TeacherDataService, userAccount, api, $q, language, notificationService) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
      // cycleFourMember: "=",
      // showInNavbar: "="
    },
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarTeacherTest', scope);
      scope.showTest = function(){
        notificationService.showNotifications();
      }
    }
  }
})